module.exports = __webpack_public_path__ + "img/logo-ccu.dd3e9af6.svg";